import { render, staticRenderFns } from "./PushRuleSetting.vue?vue&type=template&id=070ae505&"
import script from "./PushRuleSetting.vue?vue&type=script&lang=ts&"
export * from "./PushRuleSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports